export enum RichLogLevel {
  Critical = "Critical",
  Error = "Error",
  Warn = "Warn",
  Info = "Info",
  Details = "Details",
  Debug = "Debug",
}
